import { ApiHandler, createHandlerChainRunner, createHandlerChainRunnerOptionalParameter, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { UserDetailsModel } from "@theStellarBlueprint/CustomApiModels";
import { getPurchasedItems } from "@theStellarBlueprint/Services/PurchasedItemsService";
import { CustomApiHandler } from "@theStellarBlueprint/Store/CustomHandlerCreator";

type HandlerType = CustomApiHandler<any, UserDetailsModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
    props.dispatch({
        type: "Custom/Users/BeginLoadOrders",
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPurchasedItems(props.apiParameter);
};

export const DispatchCompleteLoadUserDetails: HandlerType = props => {
    props.dispatch({
        type: "Custom/Users/CompleteLoadUsersData",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadUserDetails];

const loadPurchasedItems = createHandlerChainRunner(chain, "LoadPurchasedItems");
export default loadPurchasedItems;
